import { render, staticRenderFns } from "./VGridColumn.vue?vue&type=template&id=59667868&scoped=true&functional=true&"
import script from "./VGridColumn.vue?vue&type=script&lang=js&"
export * from "./VGridColumn.vue?vue&type=script&lang=js&"
import style0 from "./VGridColumn.vue?vue&type=style&index=0&id=59667868&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "59667868",
  null
  
)

export default component.exports